import { fileItemExtensionMap } from '@constants/fileItemTypes';

/**
 * Return the file item type based on the file extension
 * @param {string} extension File extension. (Without '.')
 * @returns {string} File item type
 */
export const getFileType = extension => {
  if (!extension) return;

  const lowerExtension = extension.toLowerCase();
  const typeIndex = Object.values(fileItemExtensionMap).findIndex(item =>
    item.includes(lowerExtension)
  );
  if (typeIndex === undefined) return;

  return Object.keys(fileItemExtensionMap)[typeIndex];
};
